export default __webpack_public_path__ + "static/restauration_cover-345eaed0f65285b194efe6bc85d808c6.jpg";